import { Stack } from '@mui/material';
import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  ErrorLoadingPage,
  Loading,
  NewFilterSummary,
  NoSearchResults,
  SummaryCardNew,
  useDrawerFilter,
} from '@hapvida/hapvida-core-components';

import { EmptyResult } from '@components';
import { useAuth, useFilterParams } from '@hooks';

import { CreateBackofficeUserRouter } from '../../../BackofficeUserCreation/router';
import { backofficeUserDrawerFilterValues } from '../../constants/backofficeUserDrawerFilterValues';
import { UserBackofficeListCardMobile } from './components/userBackofficeListCardMobile';
import { UserBackofficeListSubHeaderMobile } from './components/UserBackofficeListSubHeaderMobile';
import { useBackofficeUserMobileState } from './hooks/useBackofficeUserState';

export function BackofficeUserListMobileLayout() {
  const navigate = useNavigate();
  const { backofficeUserMobileState, refreshBackofficeUserList } =
    useBackofficeUserMobileState();
  const { hasFilters } = useFilterParams();
  const { user } = useAuth();

  const userName = user?.name ?? '';

  const {
    data: dataMobile,
    isLoading,
    isError,
    hasNextPage,
    fetchNextPage,
  } = backofficeUserMobileState;

  const totalUsersLength = dataMobile?.pages[0]?.total ?? 0;

  const filterSummaryLabel = `${totalUsersLength} ${
    totalUsersLength === 1 ? 'usuário' : 'usuários'
  }`;

  const { getInitialFilter, setActiveFilters } = useDrawerFilter();
  const initialRender = useRef(true);

  useEffect(() => {
    if (initialRender.current) {
      initialRender.current = false;
      const initialUsersFilters = getInitialFilter({
        filtersConfig: backofficeUserDrawerFilterValues,
      });

      setActiveFilters(initialUsersFilters);
    }
  }, []);

  if (isLoading) {
    return (
      <Loading
        padding={8}
        message={
          <>
            Estamos carregando as informações. <br /> Em breve, tudo estará
            pronto para você
          </>
        }
      />
    );
  }

  if (isError) {
    return <ErrorLoadingPage onReloadClick={refreshBackofficeUserList} />;
  }
  const totalUserBackofficeListLength = dataMobile?.pages[0]?.total ?? 0;

  const isEmpty = totalUserBackofficeListLength === 0;

  const isEmptyResult = isEmpty && hasFilters;

  if (isEmpty && !hasFilters) {
    return (
      <EmptyResult
        message={`${userName}, nenhuma empresa está disponível para você.`}
      />
    );
  }

  return (
    <>
      <UserBackofficeListSubHeaderMobile />
      <Stack paddingY={3} gap={3}>
        <NewFilterSummary totalLabel={filterSummaryLabel} />
        <SummaryCardNew.Container>
          {isEmptyResult ? (
            <NoSearchResults padding={5} />
          ) : (
            <SummaryCardNew.Header
              subtitle="Lista dos usuários que podem acessar a plataforma na visão backoffice."
              title="Lista de usuários backoffice"
              buttonProps={{
                content: 'Novo usuário backoffice',
                variant: 'contained',
                color: 'success',
                onClick: () => navigate(CreateBackofficeUserRouter.path),
                sx: {
                  display: 'none',
                },
              }}
            />
          )}
          {!isEmptyResult && (
            <UserBackofficeListCardMobile
              fetchNextPage={fetchNextPage}
              hasNextPage={hasNextPage}
              usersListData={dataMobile}
            />
          )}
        </SummaryCardNew.Container>
      </Stack>
    </>
  );
}
